/**
 * Determines whether a date marks a device end-of-life. Currently ignores the supplied date and always reports false.
 *
 * @param _date - Date to evaluate; unused.
 * @returns Always false.
 */
const isEndOfLife = (_date: any) => false;

export { isEndOfLife };
